import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=053e2e1a&scoped=true&"
import script from "./widget.vue?vue&type=script&lang=js&"
export * from "./widget.vue?vue&type=script&lang=js&"
import style0 from "./widget.vue?vue&type=style&index=0&id=053e2e1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053e2e1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('053e2e1a')) {
      api.createRecord('053e2e1a', component.options)
    } else {
      api.reload('053e2e1a', component.options)
    }
    module.hot.accept("./widget.vue?vue&type=template&id=053e2e1a&scoped=true&", function () {
      api.rerender('053e2e1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/ticket/widget.vue"
export default component.exports